import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { where, query, average, collection, getAggregateFromServer, getCountFromServer, sum } from '@angular/fire/firestore';
import { map } from "rxjs";
import { SystemService } from "./system.service";
import { VmMachineService } from "./vm-machine.service";
@Injectable({ providedIn: 'root' })
export class OverviewService {

    constructor(
        private systemService: SystemService,
        private vmService: VmMachineService,
        private afs: AngularFirestore
    ) {

    }

    getPreviousSystemFaults(companyId, siteId, systemId) {
        return new Promise((res, rej) => {
            this.afs.collection('machineStatus', ref => ref.where('companyId', '==', companyId).where("siteId", "==", siteId).where('systemId', '==', systemId).orderBy('updatedOn', 'desc').limit(10)).get()
                .subscribe(doc => {
                    let arr = []
                    doc.forEach(data => {
                        arr.push({ ...data.data() as object, updatedOn: moment.unix(data.data()['updatedOn']).tz('Europe/Oslo').fromNow() });
                    })
                    res(arr)

                })
        })

    }

    getPreviousSystemFaults$(companyId, siteId, systemId) {
        return this.afs.collection('machineStatus', ref => ref.where('companyId', '==', companyId).where("siteId", "==", siteId).where('systemId', '==', systemId).orderBy('updatedOn', 'desc').limit(5000)).snapshotChanges().pipe(map(data => {
            return data.map(doc => {
                return {
                    ...doc.payload.doc.data() as object,
                    id: doc.payload.doc.id,
                    updatedOn: moment.unix(doc.payload.doc.data()['updatedOn']).tz("Europe/Oslo").format("DD.MM.YYYY HH:mm")
                }
            })
        }))

    }

    getActiveIssues(companyId, siteId, systemId) {
        return new Promise((res, rej) => {
            this.afs.collection('issues').ref.where('companyId', '==', companyId).where('siteId', '==', siteId).where('systemId', '==', systemId).where('active', '==', true).orderBy('createdAt', 'desc').get().then
                (doc => {
                    let arr = []
                    doc.forEach(data => {
                        arr.push({ uid: data.id, ...data.data() as object, createdAt: moment.unix(data.data()['createdAt']).tz('Europe/Oslo') });
                    })
                    res(arr)

                })
        })

    }

    getActiveIssues$() {

        return this.afs.collection('issues', ref => ref.where('active', '==', true)).snapshotChanges().pipe(map(doc => {
            return doc.map(obj => {
                return {
                    ...obj.payload.doc.data() as object,
                    dbid: obj.payload.doc.id,
                    updatedOn: moment.unix(obj.payload.doc.data()['updatedOn']).tz('Europe/Oslo').fromNow()
                }
            })
        }))


    }


    updateActiveIssueById(id, obj) {
        return this.afs.collection('issues').doc(id).update(obj)
    }



    updateActiveTask(data, code) {
        return this.afs.collection('issuesTasks', ref => ref.where('companyId', '==', data['companyId']).where('siteId', '==', data['siteId']).where('systemId', '==', data['systemId'])
            .where('status', '==', 'scheduled').where('code', '==', code)).get()
            .subscribe(async sp => {

                if (!sp.empty) {
                    const batch = this.afs.firestore.batch();

                    sp.forEach(doc => {
                        const sfRef = doc.ref
                        batch.update(sfRef, {
                            status: "cancelled",
                            updatedOn: moment().unix(),
                            updatedBy: "Automatic"
                        });
                    })
                    // Get a new write batch

                    // Update the population of 'SF'
                    console.log("before batch commit active task")
                    await batch.commit();
                    console.log("after batch commit active task")
                }
            })

    }
    getActiveIssuesCount(companyId, siteId, systemId) {
        return new Promise(async (res, rej) => {
            const transactionCollection = collection(this.afs.firestore, 'issues')// collection of users
            const q = query(transactionCollection, where('companyId', '==', companyId), where('siteId', '==', siteId), where('systemId', '==', systemId), where('active', '==', true));

            const count = await getCountFromServer(q);

            console.log("sumQuery", count.data().count);
            let data = count.data().count

            res({ count: data })
        })

    }

    getSystemName(params): Promise<any> {
        return new Promise(async (res, rej) => {
            this.afs.collection('company').doc(params.companyId)
                .collection('sites').doc(params.siteId).collection('systems').doc(params.systemId).get().subscribe((doc) => {
                    res(doc.data()['name']);
                })


        })

    }


    getTransactionSalePerDay(companyId, siteId, systemId, from, to) {
        return new Promise(async (res, rej) => {
            const transactionCollection = collection(this.afs.firestore, 'transactions')// collection of users
            const q = query(transactionCollection, where('companyId', '==', companyId), where('siteId', '==', siteId), where('systemId', '==', systemId), where('unix', '>=', from), where('unix', '<=', to));

            const count = await getCountFromServer(q);

            const sumQuery = await getAggregateFromServer(q, {
                totalIncome: sum('price'),
                totalSubscriptions: average('price')
            }); // query to sum total likes and average total subscriptions
            console.log("sumQuery", sumQuery.data(), count.data().count);
            let data = count.data().count

            res({ ...sumQuery.data(), count: data })
        })

    }

    resetMachine(companyId, siteId, systemId, machineId) {
        this.systemService.resetMachine(companyId, siteId, systemId, machineId)
    }

    collectProduct(companyId, siteId, systemId, machineId) {
        this.vmService.collectProductElevetor(companyId, siteId, systemId, machineId);

    }

}